import { makeAutoObservable } from 'mobx';
import { TGetTourResponse, TTourSearchResponse } from '@features/tour/types';

export class TourStore {
  tourDetail: TGetTourResponse = {} as TGetTourResponse;
  tourSearchResponse: TTourSearchResponse = {} as TTourSearchResponse;

  constructor() {
    makeAutoObservable(this);
  }

  setTourDetail = (detail: TGetTourResponse) => {
    this.tourDetail = detail;
  };
  setTourSearchResponse = (searchResponse: TTourSearchResponse) => {
    this.tourSearchResponse = searchResponse;
  };
}

const tourStore = new TourStore();

export default tourStore;
